import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suplemento-adulto',
  templateUrl: './suplemento-adulto.component.html',
  styleUrls: ['./suplemento-adulto.component.css']
})
export class SuplementoAdultoComponent implements OnInit {


  constructor() {}

  ngOnInit(): void {
    this.removeBackgroundImage();

  }

  removeBackgroundImage() {
    const body = document.querySelector('body.light-page');
    body.classList.remove('bg-top');
  }


}
